// core-preference-integration.model.ts
import { Resource } from "../resource/resource.model";

export class CorePreferenceIntegration extends Resource {
    corePreferenceId: string;
    integrationType: string; // "WholePreference" or "ByChannel"
    defaultMapping: ComplianceInputMapping;
    channelMappings: ChannelMapping[] = [];
    status: string;
    description: string;
    createOnTrue: boolean = true;
    createOnFalse: boolean = false;
    instanceId?: string;

    // UI helper properties (not sent to API)
    preferenceDisplay?: string;
    integrationTypeDisplay?: string;
    statusDisplay?: string;
}

export class ComplianceInputMapping {
    processingPurpose: string;
    permissionType: string;
    businessUnit: string;
    consentMapping: ConsentCodeMapping = new ConsentCodeMapping();
}

export class ConsentCodeMapping {
    trueValue: string = "yes";
    falseValue: string = "no";
}

export class ChannelMapping {
    channelId: string;
    mapping: ComplianceInputMapping = new ComplianceInputMapping();
}

// For testing integrations
export class TestIntegrationRequest {
    emailAddress: string;
    value: string;
    country: string;
    state: string;
}